import { cn } from '@repo/tailwind-config/tailwind.functions'
import { PropsWithChildren } from 'react'

type BoxProps = {
  className?: string
  style?: 'border' | 'shadow'
  isMobileScrollable?: boolean
}

const Box = ({ children, isMobileScrollable, style, className }: PropsWithChildren<BoxProps>) => {
  return (
    <div
      className={cn(
        'bg-white px-5 py-4 rounded-3xl',
        {
          'shadow-[0px_0px_26px_0px_#93939333]': style === 'shadow',
          'border border-grey-light rounded-xl flex flex-col gap-4 p-4':
            style === 'border' || style === 'shadow'
        },
        { 'mobile-scroll': isMobileScrollable === true },
        className
      )}
    >
      {children}
    </div>
  )
}

export default Box
